import { render } from "./userPhone.vue?vue&type=template&id=26886618&scoped=true"
import script from "./userPhone.vue?vue&type=script&lang=js"
export * from "./userPhone.vue?vue&type=script&lang=js"

import "./userPhone.vue?vue&type=style&index=0&id=26886618&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26886618"

export default script